import { TemplateRef } from '@angular/core';

export class ClindxConfig {
  columnList: Array<ColumnConfig>;
  customData?: any;
  table?: string;
  pagination?: boolean;
  isResponsive?: boolean;
  hasStickyHeader?: boolean;
  outerDiVClass?: string;
  tableClass?: string;
  sortState?: SortState;
  rowCondition?: RowConditionFields;
  hasFilter?: boolean;
  hasSearch?: any;
  isRowClickable?: boolean;
  hasSelect?: boolean;
  panelColumnList?: Array<ColumnConfig>;
  tableWidth?: string;
}

export class ColumnConfig {
  columnName?: string;
  columnDisplayValue?: string;
  classThName?: string;
  classTdName?: string;
  hasSort?: boolean;
  hidden?: boolean;
  cellTemplate?: TemplateRef<any>;
  args?: any;
  dataAccessor?: any;
  excludeInFilter?: boolean;
  includeInFilter?: boolean;
}

export class ClindxTableFilterConfig extends ColumnConfig {
  id?: string;
  name?: string;
  type: string;
  isMulti?: boolean;
  placeHolder?: string;
  maxLength?: number;
  minLength?: number;
}

export enum ClindxTableFilterType {
  inputType = 'inputType',
  numberType = 'numberType',
  enumType = 'enumType',
  dateType = 'dateType',
  dateRangeType = 'dateRangeType',
  dateWithValidationType = 'dateWithValidationType',
  inputTypeWithMinLength = 'inputTypeWithMinLength'
}

export class SortState {
  active: string;
  direction: string;
  sortType?: string;
}

export class RowConditionFields {
  field: string;
  color: string;
}